import { Box } from '@chakra-ui/react'

import Loader from 'src/components/widgets/Loader'

import ItListCell from '../../ItListCell'

import useActivateItList from './useActivateItList'

const ActivateItList: React.FC<{ itListId: number }> = ({ itListId }) => {
  const { isActivated } = useActivateItList(itListId)

  return isActivated ? (
    <ItListCell id={itListId} />
  ) : (
    <Box>
      <Loader mt={10} />
      <Box color="graphite" textAlign="center">
        Unlocking your ItList...
      </Box>
    </Box>
  )
}

export default ActivateItList
